import type { UserAttributes, UserPreferences } from '@cobliteam/api-lib';
import type { Permission } from '@cobliteam/permissions';
import type { TimestampInMillis } from './dates';
import type { Email } from './email';
import type { UUID } from './identifier';

export interface UserData {
  hasCameraFlag: boolean;
  hasRedeCan: boolean;
  userPreferences?: UserPreferences;
  userAttributes: UserAttributes;
  userFleets: AccessibleFleet[];
}

export enum UserRole {
  MAP_VIEW = 'map_view',
  OPERATION = 'operation',
  MANAGER = 'fleet',
  ADMINISTRATOR = 'administrator',
  USER_INSTALLER = 'user_installer',
  SAFETY_COACHER = 'safety_coacher',

  // Legacy Roles
  COBLER = 'cobler',
}

export interface User {
  id: UUID;
  name: string;
  fullName?: string;
  role: UserRole;
  lastLogin?: TimestampInMillis;
  email: Email;
  creationDate?: TimestampInMillis;
  groupsRestriction: string[];
  grantedPermissions: string[];
  hasCustomPermissions: boolean;
  active: boolean;
  phoneNumber?: string;
}

export interface UserFleet {
  fleetId: string;
  userId: UUID;
  role: UserRole;
  groupsRestriction: string[];
}

export interface SessionUser {
  id: UUID;
  name: string;
  role: UserRole;
  language?: string;
  lastLogin?: TimestampInMillis;
  email: Email;
  creationDate?: TimestampInMillis;
  timezone?: number;
  groupsRestriction: string[];
  grantedPermissions: Permission[];
  phoneNumber?: string;
}

export interface AccessibleFleet {
  id: UUID;
  name: string;
  /** Frota inativa (bloqueio por pagamento/cancelamento); ausente = ativa. */
  active?: boolean;
  associatedAt?: TimestampInMillis;
  hasNoValidGroups?: boolean;
  hasOnlyGroupsWithNoVehicles?: boolean;
}
